// extracted by mini-css-extract-plugin
export default {"action":"availability_section-module___action___e7aeee8f"};